import React, { useEffect, useState } from 'react';
import { Button, Table, TableData, TableRow, ToastMessage } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';
import AddUserModal from 'components/modals/add-user-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { UserType } from './types';
import useRoleContext from 'contexts/role.context';
import { InventoryModule, RolePermission } from 'models/permission.model';

const TABLE_HEADERS = ['Name', 'Access level', 'Role', 'Last active'];

const ManageUsers = () => {
  const { can } = useRoleContext();
  const [loading, setLoading] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [users, setUsers] = useState<UserType[]>([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const canManageUsers = can(InventoryModule.User, RolePermission.Write);

  const getUsers = async () => {
    try {
      setLoading(true);
      const res = await apiService.get('user', { params: { page: pageNumber } });
      setUsers(res?.data?.data);
      const totalNoOfPages = Math.ceil(res.data.pagination.total / res.data.pagination.page_size);
      setPageCount(totalNoOfPages);
    } catch (e) {
      toast(<ToastMessage message='User fetched successfully' type='success' />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getUsers();
  }, [pageNumber]);
  const getSelectedPage = (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    setPageNumber(pageNo);
  };
  return (
    <div>
      <PageHeaderText
        title='Manage Users'
        // description='Manage and track the quantity of items in stocks'
      >
        {canManageUsers && (
          <Button
            variant='block'
            color='primary'
            className='px-[37px] py-[9.5px] text-sm font-medium'
            onClick={() => setShowAddUserModal(true)}>
            Add User
          </Button>
        )}
      </PageHeaderText>

      <Table
        headers={TABLE_HEADERS}
        onPageChange={getSelectedPage}
        pageCount={pageCount}
        loading={loading}>
        {users?.map((user, index) => {
          return (
            <TableRow className='text-gray-12' key={index}>
              <TableData className='text-gray-10 flex gap-3 items-center'>
                <div className='w-10 h-10 bg-red-5 rounded-full grid place-items-center'>
                  <p className='text-[18px] text-white'>
                    {user.first_name.charAt(0)} {user.last_name.charAt(0)}
                  </p>
                </div>
                <div>
                  <div>
                    <h5 className='text-base font-medium text-gray-10'>
                      {user?.first_name} {user?.last_name}
                    </h5>
                  </div>
                  <div>
                    <p className='text-sm text-gray-12'>{user?.user?.email}</p>
                  </div>
                </div>
              </TableData>
              <TableData className='px-5 text-gray-5'>Mainstore</TableData>
              <TableData>{user?.roles[0]?.role?.name}</TableData>
              <TableData>30 mins ago</TableData>
            </TableRow>
          );
        })}
      </Table>

      {showAddUserModal && canManageUsers && (
        <AddUserModal show={showAddUserModal} onClose={() => setShowAddUserModal(false)} />
      )}
    </div>
  );
};
export default ManageUsers;
